'use strict';

var React = require('react');

var SvgImportStoreMajor = function SvgImportStoreMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1.014 5.836.61-3.583a1.522 1.522 0 0 1 1.51-1.253h13.733c.748 0 1.387.53 1.51 1.253l.609 3.583c.104.61-.376 1.164-1.007 1.164h-.91c-.58 0-1.11-.321-1.37-.83l-.597-1.17-.597 1.17c-.26.509-.79.83-1.37.83h-1.169c-.58 0-1.11-.321-1.369-.83l-.597-1.17-.597 1.17c-.26.509-.79.83-1.37.83h-1.169c-.58 0-1.11-.321-1.369-.83l-.597-1.17-.598 1.17c-.259.509-.789.83-1.369.83h-.91c-.63 0-1.11-.555-1.007-1.164Zm6.779 2.957a1 1 0 0 0 0 1.414l.793.793h-6.586a1 1 0 1 0 0 2h6.586l-.793.793a1 1 0 0 0 1.414 1.414l2.5-2.5a.998.998 0 0 0 .293-.704v-.006a.997.997 0 0 0-.284-.695l-.01-.01-2.499-2.5a1 1 0 0 0-1.414 0Zm10.207.207h-2v8h-12v-2h-2v2.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-8.5Z"
  }));
};

exports.SvgImportStoreMajor = SvgImportStoreMajor;
